// import React from 'react';
// import './AdminCSS/deviceupdate.css';

// const DeviceUpdate = ({ formData, setFormData, handleUpdateSubmit, setSelectedDevice }) => {
//   return (
//     <div className="popup-device">
//       <h3>Update Device</h3>
//       <label htmlFor="email">User Email:</label>
//       <input
//         type="email"
//         value={formData.email}
//         onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//         placeholder="User email"
//         required
//       />
//       <label htmlFor="mac_address">MAC Address:</label>
//       <input
//         type="text"
//         value={formData.mac_address}
//         onChange={(e) => setFormData({ ...formData, mac_address: e.target.value })}
//         placeholder="MAC Address"
//         required
//       />
//       <button onClick={handleUpdateSubmit}>Submit</button>
//       <button onClick={() => setSelectedDevice(null)}>Cancel</button>
//     </div>
//   );
// };

// export default DeviceUpdate;



import React from 'react';
import './AdminCSS/deviceupdate.css';

const DeviceUpdate = ({
  formData,
  setFormData,
  handleUpdateSubmit,
  setSelectedDevice
}) => {

  const handleSubmit = () => {
    // ✅ Require at least one identifier
    if (!formData.mac_address && !formData.imei_number) {
      alert("Provide at least MAC Address or IMEI Number.");
      return;
    }

    handleUpdateSubmit();
  };

  return (
    <div className="popup-device">
      <h3>Update Device</h3>

      <label htmlFor="email">User Email:</label>
      <input
        type="email"
        value={formData.email || ""}
        onChange={(e) =>
          setFormData({ ...formData, email: e.target.value })
        }
        placeholder="User email"
      />

      <label htmlFor="mac_address">MAC Address:</label>
      <input
        type="text"
        value={formData.mac_address || ""}
        onChange={(e) =>
          setFormData({
            ...formData,
            mac_address: e.target.value
          })
        }
        placeholder="MAC Address (optional)"
      />

      <label htmlFor="imei_number">IMEI Number:</label>
      <input
        type="text"
        value={formData.imei_number || ""}
        onChange={(e) =>
          setFormData({
            ...formData,
            imei_number: e.target.value
          })
        }
        placeholder="15-digit IMEI (optional)"
        maxLength={15}
      />

      <div className="button-group">
        <button className="submit-btn" onClick={handleSubmit}>
          Submit
        </button>

        <button
          className="cancel-btn"
          onClick={() => setSelectedDevice(null)}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeviceUpdate;